import { Pipe, PipeTransform } from '@angular/core';
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";

/**
 * Generated class for the GetContentPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'getContent',
})
export class GetContentPipe implements PipeTransform {

  constructor(public contentTranslations: ContentTranslationProvider) {

  }

  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    return this.contentTranslations.translateContent(value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/get-content/get-content.ts